import React,{useState} from 'react'
import { SubP, InputContainer, Input1 } from './Styled'
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import './Index.css'

const Button = styled.button`
    border: none;
    background: rgb(53, 69, 238);
    color: white;
    font-weight: 500;
    padding: 7px 30px;
    border-radius: 32px;
    margin-right: 5px;
    white-space: nowrap;
`
const P = styled.p`
    margin-bottom: 10px;
    text-align: center;
    color: white;
    // color: #F7A601;
    font-size: 18px;
    font-weight: 600;
`
const P1 = styled.p`
    font-size: 65px;

    @media (max-width: 1000px){
        font-size: 50px;
        margin-top: 40px;
    }

    @media (max-width: 1000px){
        font-size: 40px;
    }
`

export default function Trade() {
    const [email, setEmail]=useState('');
    const handleChange=(e)=>{
        setEmail(e.target.value);
    }
    const navigate = useNavigate();
    return (<>
        <div className='container-fluid p-0 imagebgWrapper' style={{ backgroundColor: '#08021C', minHeight: '50rem' }}>
            <div className='row m-0'>
                <div className='col-md-12 text-center text-white mt-5 d-flex flex-column justify-content-center align-items-center'>
                    <P1 className='header-text trde-crpt text-white fw-bold'>Buy, sell, and earn crypto</P1>
                    <SubP className='header-text text-white  mt-2'>Secure and fast P2P crypto trading with over 400+ payment methods</SubP>
                </div>
            </div>
            <div className='row m-0 d-flex flex-column justify-content-center align-items-center position-relative  '>
                <P>Qvani users can earn up to $2000 just by taking advantage of our rewards. </P>
                <div className='col-md-6 col-sm-9'>
                    <InputContainer>
                        <Input1
                            name='email'
                            value={email}
                            onChange={handleChange}
                            placeholder='Your Email/Phone number'
                        />
                        <Button onClick={() =>{ navigate(`/signup/${email}`)}}>Sign Up</Button>                        
                    </InputContainer>
                </div>
            </div>

        </div>

    </>);
}